import React from 'react';
import PropTypes from 'prop-types';

import APIClient from './APIClient';

class ConfirmForm extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  state = {
    error: null,
  };

  componentDidMount() {
    const queryString = this.props.location.search;
    const matches = queryString.match(/\?userId=(\d+)&token=([a-f0-9]+)/);
    if (!matches) {
      const error = new Error(`Invalid confirmation URL.`);
      this.setState({ error });
      return;
    }

    const userId = matches[1];
    const token = matches[2];

    APIClient.shared.confirm(userId, token)
      .then(() => this.props.history.push('/log-in'))
      .catch(error => this.setState({ error }))
  }

  render() {
    return (
      <div className="ConfirmForm">
        ConfirmForm component
      </div>
    );
  }
}

export default ConfirmForm;



// WEBPACK FOOTER //
// ./src/ConfirmForm.js